// src/services/inventory.js
import api from './auth'; // Votre instance axios déjà configurée

const INVENTORY_API = '/inventory'; // Base path pour l'inventaire

export const inventoryService = {
  // Stocks par succursale
  getStocks: (params) => api.get(`${INVENTORY_API}/stocks-succursale/`, { params }),
  
 // Ajuster le stock
ajusterStock: (stockId, data) => 
  api.post(`${INVENTORY_API}/stocks-succursale/${stockId}/ajuster/`, data),

// ✅ Ajouter cette ligne
configurerStock: (stockId, data) => 
  api.patch(`${INVENTORY_API}/stocks-succursale/${stockId}/configurer/`, data),
  
  // Transférer du stock entre succursales
  transfertStock: (data) => 
    api.post(`${INVENTORY_API}/stocks-succursale/transfert/`, data),
  
  // Mouvements de stock
  getMouvements: (params) => 
    api.get(`${INVENTORY_API}/mouvements-stock/`, { params }),
  
  // Stats
  getStocksRupture: () => api.get(`${INVENTORY_API}/produits/en_rupture/`),
  getStocksFaible: () => api.get(`${INVENTORY_API}/produits/stock_faible/`),
};

// ⚠️ Service SÉPARÉ pour les succursales (PAS sous /inventory)
export const succursaleService = {
  getSuccursales: () => api.get('/succursales/'),
  getSuccursale: (id) => api.get(`/succursales/${id}/`),
  createSuccursale: (data) => api.post('/succursales/', data),
  updateSuccursale: (id, data) => api.put(`/succursales/${id}/`, data),
  deleteSuccursale: (id) => api.delete(`/succursales/${id}/`),
  getManagers: () => api.get('/succursales/available_managers/'),
};